import request from "@/utils/request";

export function GetCustomerDetail(params) {
  return request({
    url: "/h5/index/getCustomerDetail",
    method: "post",
    params,
  });
}

export function RefuseReceiver(params) {
  return request({
    url: "/h5/index/refuseReceiver",
    method: "post",
    params,
  });
}

export function DealNow(params) {
  return request({
    url: "/h5/index/dealNow",
    method: "post",
    params,
  });
}

export function AddClicks(params) {
  return request({
    url: "/h5/Index/addClicks",
    method: "post",
    params,
  });
}